export default __webpack_public_path__ + "static/media/rt.bbb883b6.png";